/**
 * @file
 * @description English translation file
 */
export default {
};
